module.exports = __webpack_public_path__ + "img/j2.1d9cd550.png";